import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./theme/tokens.css";
import "./styles/globals.css";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { captureInviteFromUrl } from "./utils/inviteToken";

// Einladungstoken VOR dem Login-Redirect sichern (Query geht sonst verloren).
captureInviteFromUrl();

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

root.render(
  <>
    <App />
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
